import { Typography } from '@mui/material';
import { FC } from 'react';

import CustomButton from 'components/CustomButton';

import { OrderItem } from 'types/pos.interface';

import { AmountButtonRow, AmountContentRow, AmountWrapper } from './index.styled';

interface OrderAmountProps {
  items: OrderItem[];
}

const OrderAmount: FC<OrderAmountProps> = ({ items }) => {
  const total = items.reduce((acc, item) => acc + item.price, 0);

  return (
    <AmountWrapper>
      <AmountContentRow>
        <Typography variant="h6">Products:</Typography>
        <Typography variant="h6">{`$${total.toFixed(2)}`}</Typography>
      </AmountContentRow>
      <AmountContentRow>
        <Typography variant="h6">Products Discounts:</Typography>
        <Typography variant="h6">$0.00</Typography>
      </AmountContentRow>
      <AmountContentRow>
        <Typography variant="h6">SubTotal:</Typography>
        <Typography variant="h6">{`$${total.toFixed(2)}`}</Typography>
      </AmountContentRow>
      <AmountContentRow>
        <Typography variant="h6">Total Tax:</Typography>
        <Typography variant="h6">$0.00</Typography>
      </AmountContentRow>
      <AmountButtonRow>
        <CustomButton
          id="button-amountDue"
          fullWidth
        >
          <Typography variant="h6">
            {`Amount Due $${total.toFixed(2)}`}
          </Typography>
        </CustomButton>
      </AmountButtonRow>
    </AmountWrapper>
  );
};

export default OrderAmount;
